import { compose } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import { withLogger } from 'shell/hoc/withLogger';
import { AD_GROUP_LIST } from 'constants/groups';
import { setActiveUserADGroup } from 'modules/shell/actions';
import SelectActiveADGroup from './SelectActiveADGroup';
import styles from './SelectActiveADGroup.styles';

const mapStateToProps = ({
  user: {
    data: { groups },
  },
}) => ({
  availableADGroups: AD_GROUP_LIST.filter(({ name }) => groups.includes(name)),
});

const mapDispatchToProps = {
  onADGroupSelect: setActiveUserADGroup,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withStyles(styles),
  withLogger(),
)(SelectActiveADGroup);
